// 运行时配置（来自 public/runtime-config.js，不参与打包混淆，可线上直接改）
const RUNTIME_CONFIG =
  (typeof window !== 'undefined' && window.__APP_RUNTIME_CONFIG__) || {}

// 启动时打印当前加载的运行时配置版本，便于线上排查
if (typeof window !== 'undefined') {
  const v = RUNTIME_CONFIG.CONFIG_VERSION || '(missing - using build-time defaults)'
  // eslint-disable-next-line no-console
  console.info('[runtime-config] version:', v)
}

// 应用配置
export const APP_CONFIG = {
  // 后端 API 地址
  BASE_API: 'https://datas.8090pay.com',

  // 应用信息
  APP_ID: 15,
  APP_KEY: '0C0qiICSs2exkkrjwxjlEQ==',

  // 支付配置
  DEFAULT_PAYMENT_METHOD: 'epay_alipay',

  // 其他配置
  TIMEOUT: 15000,

  // 当前运行时配置版本号（线上修改 runtime-config.js 后会变化，便于排查）
  CONFIG_VERSION: RUNTIME_CONFIG.CONFIG_VERSION || 'unknown',

  // 业务类型配置
  // 可选值:
  // 'electronics', 'internet', 'trading', 'service', 'internet_dev', 'corporate_website'
  BUSINESS_TYPE: 'corporate_website',

  // 购买服务开关
  // 真正生效的值来自 public/runtime-config.js（部署后可直接在线编辑 dist/runtime-config.js）。
  // 下面这行只是回退默认值——当 runtime-config.js 缺失或字段未提供时使用。
  ENABLE_PURCHASE:
    RUNTIME_CONFIG.ENABLE_PURCHASE !== undefined
      ? RUNTIME_CONFIG.ENABLE_PURCHASE === true
      : true,

  // 页面显示配置
  PAGE_TITLE: '新疆爱游互娱',

  // 备案信息
  ICP_NUMBER: '新ICP备2026002725号',
  ICP_LINK: 'https://beian.miit.gov.cn/',

  // 公司资料配置
  COMPANY_PROFILE: {
    fullName: '新疆爱游互娱网络科技有限公司',
    shortName: '新疆爱游互娱',
    establishedYear: '2021年',
    location: '新疆维吾尔自治区乌鲁木齐市',
    industry: '科技推广和应用服务业',
    registeredCapital: '5万人民币',
    licenses: '行政许可3个',
    heroTitle: '立足乌鲁木齐的科技服务企业',
    heroSubtitle: '围绕企业展示、基础信息呈现和数字化形象建设，提供更清晰、更可信的官网内容表达。',
    companyIntro: '新疆爱游互娱网络科技有限公司成立于2021年，位于新疆维吾尔自治区乌鲁木齐市，是一家以从事科技推广和应用服务业为主的企业。企业注册资本5万人民币。根据公开信息，通过天眼查大数据分析，公司拥有行政许可3个。',
    aboutTitle: '公司介绍',
    companyVision: '以规范、清晰、可信的对外表达，建立企业在数字渠道中的基础形象。',
    aboutPoints: [
      '成立于2021年，位于新疆维吾尔自治区乌鲁木齐市',
      '所属行业为科技推广和应用服务业',
      '企业注册资本5万人民币',
      '公开信息显示公司拥有行政许可3个',
    ],
    serviceTitle: '业务方向',
    serviceItems: [
      {
        name: '企业官网展示',
        desc: '用于对外展示企业主体信息、品牌形象、服务能力和合作入口。',
      },
      {
        name: '信息整合呈现',
        desc: '将公司简介、基础信息、经营情况等资料整理成结构化页面内容。',
      },
      {
        name: '数字化形象建设',
        desc: '通过规范的企业官网内容提升初次访问时的专业感与可信度。',
      },
    ],
    highlightItems: [
      {
        title: '主体信息完整',
        desc: '围绕企业名称、成立时间、地区、行业和注册资本形成清晰展示。',
      },
      {
        title: '公开信息可核验',
        desc: '将行政许可等可验证信息纳入页面表达，增强访客信任感。',
      },
      {
        title: '适合持续扩展',
        desc: '当前结构可继续接入产品、案例、新闻动态和招聘等模块。',
      },
    ],
    operationItems: [
      { label: '企业名称', value: '新疆爱游互娱网络科技有限公司' },
      { label: '成立时间', value: '2021年' },
      { label: '所属行业', value: '科技推广和应用服务业' },
      { label: '注册资本', value: '5万人民币' },
      { label: '公开信息', value: '行政许可3个' },
      { label: '所在地区', value: '新疆维吾尔自治区乌鲁木齐市' },
    ],
    cooperationSteps: [
      {
        title: '需求沟通',
        desc: '明确企业展示重点、对外信息口径和页面结构要求。',
      },
      {
        title: '资料整理',
        desc: '梳理公司简介、基础信息、经营情况和联系信息等内容。',
      },
      {
        title: '页面上线',
        desc: '完成官网页面搭建后持续补充真实电话、邮箱、地址和备案资料。',
      },
    ],
    contactTitle: '联系信息',
    contactSubtitle: '建议后续继续补充真实联系电话、邮箱、办公地址和备案主体信息。',
    contactPhone: '',
    contactEmail: '',
    contactAddress: '新疆乌鲁木齐经济技术开发区（头屯河区）',
    officeHours: '周一至周五 10:00 - 19:00',
    contactWechat: '',
    filingSubject: '新疆爱游互娱网络科技有限公司',
    contactItems: [
      { label: '公司名称', value: '新疆爱游互娱网络科技有限公司' },
      { label: '所在地区', value: '新疆维吾尔自治区乌鲁木齐市' },
      { label: '所属行业', value: '科技推广和应用服务业' },
      { label: '经营情况', value: '行政许可3个' },
    ],
    productSectionTitle: '主营服务',
    productItems: [
      {
        name: '互动营销活动页定制',
        desc: '面向品牌活动、节日促销和渠道推广场景，提供轻量互动页面与专题活动内容搭建。',
        tags: ['活动专题', '互动营销', '品牌推广'],
      },
      {
        name: '企业展示官网搭建',
        desc: '围绕企业主体信息、服务内容、合作流程和联系渠道，打造可长期运营的展示型官网。',
        tags: ['企业官网', '品牌展示', '内容整合'],
      },
      {
        name: '数字内容包装服务',
        desc: '为企业提供基础文案整理、页面结构规划和对外展示内容包装，提升整体专业度。',
        tags: ['内容包装', '页面策划', '数字化形象'],
      },
    ],
    caseSectionTitle: '案例展示',
    caseItems: [
      {
        title: '本地生活品牌活动专题页',
        summary: '为区域商家打造线上活动专题页，集中展示活动玩法、门店信息和用户参与入口。',
        result: '帮助客户在短周期内完成品牌曝光和活动信息统一发布。',
      },
      {
        title: '企业数字名片官网项目',
        summary: '围绕企业简介、基础信息、服务能力和联系合作，搭建轻量化数字官网。',
        result: '显著提升初次接触阶段的信息完整度与商务沟通效率。',
      },
      {
        title: '招商展示内容包装项目',
        summary: '对客户原有零散资料进行整合重构，形成适用于对外招商和合作洽谈的展示页面。',
        result: '让页面更易读、更正式，也更利于业务人员直接转发使用。',
      },
    ],
  },
}
